import { useContext } from "react";
import { Link } from "react-router-dom";
import { ASSET_HOST_BASE_URL, independentParty, otherParty, PROPORTIONAL_SEAT, TOTAL_SEAT } from "../../../../config";
import LangContext from "../../../../contexts/LangContext";
import { getPercentage, translate, translateNumber, translatePercentage } from "../../../../helper";
import { LoaderCard } from "../../../common/Loader";
import "./index.css";

const AllPartiesDRPR = (props) => {
  const { lang } = useContext(LangContext);

  let majorParties = props.allParties.dr.map((x) => ({ party: x.party, seat: x.win }));
  props.allParties.pr.forEach((px) => {
    const exist = majorParties.find((mp) => mp.party === px.party);
    if (exist) {
      exist.seat += px.seat;
    }
  });

  majorParties = majorParties.sort((a, b) => b.seat - a.seat);

  let totalSeat = 0;
  let drTotalSeat = 0;
  let prTotalSeat = 0;
  let maxSeat = 0;

  if (props.fetched && props.allParties.pr.length > 0 && props.allParties.dr.length > 0) {
    totalSeat = majorParties.reduce((x, y) => x + y.seat, 0);
    drTotalSeat = props.allParties.dr.reduce((x, y) => x + y.win, 0);
    prTotalSeat = props.allParties.pr.reduce((x, y) => x + y.seat, 0);
    maxSeat = majorParties[0].seat;
  }

  // console.log(majorParties, 'majorparites', prTotalSeat, drTotalSeat, maxSeat, props)

  return (
    <div className="container-fluid card sh-card-chart">
      {!props.fetched && <LoaderCard />}
      <div className="row" style={{ opacity: props.fetched ? "1" : 0.5 }}>
        <div className="col-md-12 sh-chart sh-top-party">
          <h2 className="text-center">{translate("major_parties", lang)}</h2>
          <div className="row sh-chart-pie">
            <div className="col-sm-12">
              <div className="row">
                <div className="col-md-12 col-sm-12 col-xs-12">
                  <h4 className="text-center">{translate("total", lang) + " " + translate("seat", lang) + " (" + translate("direct", lang) + ")"} </h4>
                  <div className="row">
                    <div className="col-md-12">
                      <div id="global-lead-pie" className="hidden-xs"></div>
                    </div>
                    <div className="col-md-12 sh-progress-stat">
                      <div className="box">
                        {majorParties.map((mparty, i) => {
                          const party = props.parties.find((par) => par.code === mparty.party) || independentParty;
                          const seatDr = props.allParties.dr.find((p) => p.party === mparty.party) || { party: mparty.party, win: 0 };
                          const seatPr = props.allParties.pr.find((p) => p.party === mparty.party) || { party: mparty.party, seat: 0 };

                          return (
                            <div key={i}>
                              <label className="sh-progress-bar-label" htmlFor="">
                                <img
                                  src={ASSET_HOST_BASE_URL + "/images/parties/" + party.code.toUpperCase() + ".png"}
                                  alt={party.code.toUpperCase()}
                                  onError={({ currentTarget }) => {
                                    currentTarget.onerror = null; // prevents looping
                                    currentTarget.src = ASSET_HOST_BASE_URL + "/images/parties/O.png";
                                  }}
                                  className="pull-left sh-party-symbol"
                                  width="20px"
                                  height="20px"
                                />
                                <Link to={"/candidates" + (mparty.party === "O" ? "" : "/" + mparty.party) + "?lang=" + lang}>{party["short_name_" + lang] || party["name_" + lang]}</Link>
                              </label>
                              <span className="pull-right data">{translateNumber(seatDr.win , lang) + " (" + translatePercentage(seatDr.win , drTotalSeat , lang) + ")"}</span>
                              <div className="progress">
                                <div className="progress-bar" role="progressbar" style={{ width: getPercentage(seatDr.win, maxSeat), backgroundColor: party.color, opacity: 1 }}>
                                  {translateNumber(seatDr.win, lang) + " (" + translatePercentage(seatDr.win, drTotalSeat, lang) + ")"}
                                </div>
                               
                              </div>
                            </div>
                          );
                        })}
                        <div>
                          <label className="sh-progress-bar-label" htmlFor=""></label>
                          <label>
                            <b>{translate("total", lang)}</b>
                          </label>
                          <span className="pull-right data">
                            <b>{translateNumber(drTotalSeat , lang)}</b>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllPartiesDRPR;
